<div
    class="agpr-promptCard"
    [attr.id]="id ? (id + '_promptCard') : null"
    [ngClass]="{'agpr-promptCard-disabled' : disabled}"
>
    @if (showIcon) {
        <div
            class="agpr-promptCard-icon"
            [attr.id]="id ? (id + '_promptCard_icon') : null"
        >
            <span class="fa-kit-duotone fa-agpr-ai"></span>
        </div>
    }
    <div
        class="agpr-promptCard-title"
        [attr.id]="id ? (id + '_promptCard_title') : null"
        [agprTooltip]="title | localize"
    >
        {{ title | localize }}

        <span
            *ngIf="tooltipInfo"
            class="agpr-promptCard-title-tooltip agpr-infoIconStyle fa-regular fa-circle-info"
            role="img"
            [attr.id]="id ? (id + '_promptCard_titleTooltip') : null"
            [agprTooltip]="tooltipInfo | localize"
        ></span>
    </div>

    @if (canEdit) {
        <div class="agpr-promptCard-actions-spacer"></div>
        <div
            class="agpr-promptCard-actions"
            [attr.id]="id ? (id + '_promptCard_actions') : null"
        >
            <agpr-button
                class="agpr-promptCard-contextButton"
                [id]="id ? (id + '_promptCard_editButton') : null"
                (click)="edit()"
                icon="fa-regular fa-duotone fa-pen"
                tooltip="Mention.workbench.insights.prompt.custom.prompt.edit"
                tooltipPosition="top"
                [style]="buttonTypes.contextMenu"
            ></agpr-button>
            <agpr-button
                class="agpr-promptCard-contextButton"
                [id]="id ? (id + '_promptCard_deleteButton') : null"
                (click)="delete()"
                icon="fa-regular fa-duotone fa-trash-can"
                tooltip="Mention.workbench.insights.prompt.custom.prompt.delete"
                tooltipPosition="top"
                [style]="buttonTypes.contextMenu"
            ></agpr-button>
        </div>
    }
</div>
